import { useQuery } from "@tanstack/react-query";
import { getTotalCallCount } from "../api/getTotalCallCount";

export const useTotalCallCount = () => {
    const { data, isLoading, isError } = useQuery({
        queryKey: [`call-count`],
        queryFn: async () => getTotalCallCount(),
        refetchOnWindowFocus: false,
        retry: 0,
        gcTime: 0,
    });
    return { data, isLoading, isError };
};
